import type { ConsentCategory } from '@schibsted/sourcepoint';
import type { ConsentRegistryImpl } from './types.js';

import { ALL_CATEGORIES } from './consts.js';

// TODO: figure out which cookies require which consents
export type CookieName = '';

const data: Partial<Record<CookieName, ConsentCategory[]>> = {};

export const registry: ConsentRegistryImpl<CookieName> = {
  getConsents: async function (cookieName) {
    // fallback to require all consents to be on the safe side.
    return data[cookieName] ?? ALL_CATEGORIES;
  },
};
